import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { getJson } from 'session';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CmsContext from 'context/CmsContext';
// import moment from 'moment';
import { convertToNumber } from 'utils/convertToNumber';
import { Acl } from 'modules/common/components/Acl';
import Transaction from 'modules/common/components/Transaction';
// import Requirements from 'modules/BPLS/container/applications/components/Requirements';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import Requirements from 'modules/civil-registry/container/birth/components/Requirements';
import FeesInformation from 'modules/common/components/FeesInformation';
// import FeesTags from 'modules/civil-registry/components/FeesTags';
import DocumentInformation from 'modules/common/components/DocumentInformation';
import RequestorInformation from 'modules/common/components/RequestorInformation';
import FindMarriageCertificateModal from '../components/FindMarriageCertificateModal';
// import VerifyReceipt from '../components/VerifyReceipt';
import UpdateModal from '../components/UpdateModal';
import UpdateRegistry from '../components/UpdateRegistry';
import ViewLogsModal from '../components/ViewLogsModal';
import ApplyDiscountModal from '../components/ApplyDiscountModal';
import * as action from '../action';
import * as c from '../constant';
import ForPickupModal from '../components/ForPickupModal';

function MarriageContent({
  transactionInfo,
  showTransaction,
  approveTransaction,
  clearTransaction,
  startAssessment,
  isAssessting,
  isLoading,
  match,
  taxpayer,
  selectedBirth,
  taxpayerProfile,
  permissions,
  approving,
  cancelApplication,
  filter,
  onCancelAssessment,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const selectedTransaction = match.params.id;
  const getAdministrator = getJson('enableProfile');
  const isStartAssessment = _.get(
    transactionInfo,
    'attributes.is_start_assessment'
  );
  const transactionStatus = _.get(
    transactionInfo,
    'attributes.transaction_status'
  );

  const onStartAssessment = () => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to ${
        isStartAssessment ? 'Stop' : 'Start'
      } assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleEdit = (data) => (e) => {
    const dataAttrib = _.get(data, 'attributes');
    const moduleAttrib = _.get(data, 'included.module.attributes');
    const fieldValues = {
      ...(moduleAttrib && moduleAttrib),
      region_code: _.get(moduleAttrib, 'mailing_address_region_code') || '',
      province_code: _.get(moduleAttrib, 'mailing_address_province_code') || '',
      municipality_code:
        _.get(moduleAttrib, 'mailing_address_municipality_code') || '',
      barangay_code: _.get(moduleAttrib, 'mailing_address_barangay_code') || '',
      street: _.get(moduleAttrib, 'mailing_address_street') || '',
      valid_id_to_present: _.get(dataAttrib, 'valid_id_to_present'),
      purpose_country_code: _.get(moduleAttrib, 'purpose_specify_country_code'),
    };
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal updateList={fieldValues} id={data.id} filter={filter} />
      ),
      title: `Edit Marriage Certificate`,
      modalSize: 'modal-lg',
    });
  };

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const handleDeliveryOption = (transaction, status) => (e) => {
    e.preventDefault();

    let title;

    if (status === 'FOR PICK-UP') {
      title = 'for pick-up';
    }

    if (status === 'ISSUED') {
      title = 'issued';
    }

    setModal({
      isOpen: true,
      content: (
        <ForPickupModal
          title={title}
          status={status}
          selected={selectedBirth}
          transactionInfo={transaction}
        />
      ),
      title: `Confirmation`,
      modalSize: 'modal-md',
    });
  };

  // const onReceive = (e) => {
  //   e.preventDefault();

  //   startAssessment(selectedBirth, () => {
  //     approveTransaction(
  //       selectedBirth,
  //       {
  //         remarks: 'The document was received',
  //         status: 'ISSUED',
  //       },
  //       () => {
  //         showTransaction(selectedBirth);
  //         setModal({ isOpen: false });
  //       }
  //     );
  //   });
  // };

  const onPickup = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to tag as for pick-up this application?',
      (remarks) => {
        approveTransaction(
          selectedBirth,
          {
            remarks,
            status: 'FOR PICK-UP',
          },
          () => {
            showTransaction(selectedBirth);
            setModal({ isOpen: false });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleFindMarriageCertificate = (type) => (e) => {
    e.preventDefault();
    const extName = _.get(taxpayer, 'extension_name')
      ? _.get(taxpayer, 'extension_name')
      : '';
    const reTaxpayer = {
      ...taxpayer,
      extension_name: extName,
    };
    setModal({
      isOpen: true,
      content: (
        <FindMarriageCertificateModal
          type={type}
          transactionInfo={transactionInfo}
          searchParams={reTaxpayer}
          id={selectedBirth}
        />
      ),
      title: `View Certificate`,
      modalSize: 'modal-xxl',
      // noCloseButton: true,
    });
  };

  const handleUpdateRegistry = (val) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateRegistry info={val} />,
      title: 'Update Registry Number ',
      modalSize: 'modal-md',
    });
  };

  // const showVerifyReceipt = (status) => {
  //   return ['FOR PAYMENT CONFIRMATION'].includes(status);
  // };

  // const handleVerifyReceipt = (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: (
  //       <VerifyReceipt transactionInfo={transactionInfo} id={selectedBirth} />
  //     ),
  //     title: `Assess Payment Receipt`,
  //     modalSize: 'modal-md',
  //   });
  // };

  const handleViewLogs = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewLogsModal id={selectedTransaction} />,
      title: `View Logs`,
      modalSize: 'modal-lg',
    });
  };

  const handleApplyDiscount = () => {
    const amount = _.get(transactionInfo, 'attributes.amount', 0);
    const discount = +_.get(transactionInfo, 'attributes.discount', 0);
    const originalAmount = +_.get(
      transactionInfo,
      'attributes.original_amount',
      0
    );

    setModal({
      isOpen: true,
      content: (
        <ApplyDiscountModal
          amount={convertToNumber(amount)}
          discount={convertToNumber(discount)}
          originalAmount={convertToNumber(originalAmount)}
          id={_.get(transactionInfo, 'id')}
        />
      ),
      title: Number(_.get(transactionInfo, 'attributes.discount'))
        ? 'Update Discount'
        : 'Apply Discount',
      modalSize: 'modal-md',
    });
  };

  const handleCancelApplication = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to cancel this application?',
      (remarks) => {
        cancelApplication(
          selectedBirth,
          {
            remarks,
          },
          () => {
            showTransaction(selectedBirth);
            setModal({ isOpen: false });
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const handleCancelAssessment = () => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to cancel assessment this transaction?',
      (remarks) => {
        onCancelAssessment(
          selectedTransaction,
          {
            remarks,
          },
          () => {
            showTransaction(selectedTransaction);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  // eslint-disable-next-line consistent-return
  const checkAdministratorAssessor = () => {
    if (isStartAssessment > 0) {
      return (
        +_.get(getAdministrator, 'id') ===
        +_.get(transactionInfo, 'attributes.start_assess_by')
      );
    }
    if (isStartAssessment === 0) return true;
  };

  const commonRedBtn = 'gen-btn btn btn-danger font-weight-bold';
  const commonBtnClass =
    'gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold';

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1 ">
              {/* BORDER */}
              <div className="card border-primary p-2">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'husband_first_name')} ${_.get(
                              taxpayer,
                              'husband_middle_name'
                            )} ${_.get(taxpayer, 'husband_last_name')} ${_.get(
                              taxpayer,
                              'wife_first_name'
                            )} ${_.get(taxpayer, 'wife_middle_name')} ${_.get(
                              taxpayer,
                              'wife_last_name'
                            )}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'husband_first_name')} ${
                          _.get(taxpayer, 'husband_middle_name') || ''
                        } ${_.get(taxpayer, 'husband_last_name')} ${
                          _.get(taxpayer, 'husband_extension_name') || ''
                        } & ${_.get(taxpayer, 'wife_first_name')} ${
                          _.get(taxpayer, 'wife_middle_name') || ''
                        } ${_.get(taxpayer, 'wife_last_name')} ${
                          _.get(taxpayer, 'wife_extension_name') || ''
                        }`}
                      </h1>
                    </div>
                  </div>

                  {/* ----------- BUTTONS ----------- */}
                  {/* UPPER BUTTON/S */}
                  <div
                    className="d-flex justify-content-end mb-2 flex-wrap"
                    style={{ gap: '.5rem' }}
                  >
                    <button
                      type="button"
                      onClick={handleViewLogs}
                      className={commonBtnClass}
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        <>View Logs</>
                      )}
                    </button>
                  </div>

                  {/* MID BUTTON/S */}
                  <div
                    className="d-flex justify-content-end mb-2 flex-wrap"
                    style={{ gap: '.5rem' }}
                  >
                    {['FOR CHECKING', 'FOR APPEARANCE'].indexOf(
                      transactionStatus
                    ) > -1 &&
                    isStartAssessment === 1 &&
                    Acl(permissions, [
                      'ASSESS MARRIAGE CERTIFICATE APPLICATION',
                    ]) &&
                    checkAdministratorAssessor() ? (
                      <>
                        <button
                          type="button"
                          onClick={handleApplyDiscount}
                          className={commonBtnClass}
                        >
                          {isLoading ? (
                            <i className="fa fa-spin fa-spinner" />
                          ) : (
                            <>Apply Discount</>
                          )}
                        </button>
                        <button
                          type="button"
                          onClick={handleFindMarriageCertificate('check')}
                          className={commonBtnClass}
                        >
                          Assess Application
                        </button>
                      </>
                    ) : null}

                    {/* {showVerifyReceipt(transactionStatus) ? (
                      <button
                        onClick={handleVerifyReceipt}
                        className={commonBtnClass}
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    ) : null} */}

                    {['FOR CHECKING', 'FOR APPEARANCE'].indexOf(
                      transactionStatus
                    ) > -1 &&
                    Acl(permissions, [
                      'START ASSESSMENT MARRIAGE CERTIFICATE',
                    ]) &&
                    checkAdministratorAssessor() &&
                    !isStartAssessment ? (
                      <button
                        type="button"
                        onClick={onStartAssessment(transactionInfo)}
                        className={commonBtnClass}
                      >
                        Start Assessment
                      </button>
                    ) : null}

                    {['FOR PRINTING', 'FOR PICK-UP', 'ISSUED'].indexOf(transactionStatus) > -1 &&
                    Acl(permissions, ['VIEW MARRIAGE CERTIFICATE']) &&
                    _.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_PROCESS_TYPE') === 'DIGITAL' &&
                    checkAdministratorAssessor() ? (
                      <button
                        type="button"
                        onClick={handleFindMarriageCertificate('view')}
                        className={commonBtnClass}
                      >
                        View Certificate
                      </button>
                    ) : null}

                    {['FOR DELIVERY'].indexOf(transactionStatus) > -1 &&
                    isStartAssessment === 0 &&
                    Acl(permissions, [
                      'START ASSESSMENT MARRIAGE CERTIFICATE',
                    ]) ? (
                      <button
                        disabled={approving || isAssessting}
                        type="button"
                        onClick={onPickup}
                        className={commonBtnClass}
                      >
                        Tag as for PICK-UP
                      </button>
                    ) : null}

                    {['FOR DELIVERY', 'FOR PICK-UP'].indexOf(
                      transactionStatus
                    ) > -1 &&
                    Acl(permissions, [
                      'START ASSESSMENT MARRIAGE CERTIFICATE',
                    ]) ? (
                      <button
                        disabled={approving || isAssessting}
                        type="button"
                        onClick={handleDeliveryOption(
                          transactionInfo,
                          'ISSUED'
                        )}
                        className={commonBtnClass}
                      >
                        Tag as Issued
                      </button>
                    ) : null}

                    <button
                      onClick={handleUpdateRegistry(transactionInfo)}
                      className={commonBtnClass}
                      type="button"
                    >
                      Update Registry No.
                    </button>

                    {['FOR CHECKING', 'FOR APPEARANCE'].indexOf(
                      transactionStatus
                    ) > -1 &&
                    checkAdministratorAssessor() &&
                    isStartAssessment ? (
                      <button
                        onClick={handleEdit(transactionInfo)}
                        className={commonBtnClass}
                        type="button"
                      >
                        Edit
                      </button>
                    ) : null}

                    {isStartAssessment === 0 &&
                      transactionStatus === 'FOR PRINTING' &&
                      Acl(permissions, ['RECEIVE MARRIAGE CERTIFICATE']) && (
                        <button
                          disabled={approving || isAssessting}
                          onClick={handleDeliveryOption(
                            transactionInfo,
                            'FOR PICK-UP'
                          )}
                          className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                          type="button"
                        >
                          {_.get(
                            transactionInfo,
                            'attributes.delivery_location'
                          )
                            ? 'Tag as for Delivery'
                            : 'Tag as for Pick-up'}
                        </button>
                      )}
                  </div>

                  {/* LOWER BUTTON/S */}
                  <div
                    className="d-flex justify-content-end mb-2 flex-wrap"
                    style={{ gap: '.5rem' }}
                  >
                    {['FOR CHECKING', 'FOR APPEARANCE'].indexOf(
                      transactionStatus
                    ) > -1 &&
                    Acl(permissions, [
                      'START ASSESSMENT MARRIAGE CERTIFICATE',
                    ]) &&
                    checkAdministratorAssessor() &&
                    isStartAssessment ? (
                      <button
                        type="button"
                        onClick={onStartAssessment(transactionInfo)}
                        className={commonRedBtn}
                      >
                        Stop Assessment
                      </button>
                    ) : null}

                    {['FOR CHECKING'].indexOf(transactionStatus) > -1 ? (
                      <button
                        onClick={handleCancelApplication}
                        className={commonRedBtn}
                        type="button"
                      >
                        Cancel Application
                      </button>
                    ) : null}

                    {['PENDING', 'FOR RESUBMISSION'].indexOf(
                      transactionStatus
                    ) > -1 ? (
                      <button
                        type="button"
                        onClick={handleCancelAssessment(transactionInfo)}
                        className={commonRedBtn}
                      >
                        {isLoading ? (
                          <i className="fa fa-spin fa-spinner" />
                        ) : (
                          <>Cancel Assessment</>
                        )}
                      </button>
                    ) : null}
                  </div>

                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Document Information</Tab>
                      <Tab>Requestor Information</Tab>
                      <Tab>Requirements</Tab>
                      <Tab>Fees</Tab>
                      {/* {transactionStatus === 'FOR CHECKING' &&
                        isStartAssessment === 1 && <Tab>Fees Tags</Tab>} */}
                    </TabList>
                    <TabPanel>
                      <Transaction
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                        module="lcr"
                      />
                    </TabPanel>
                    <TabPanel>
                      <DocumentInformation
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <RequestorInformation
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <Requirements
                        data={_.get(
                          transactionInfo,
                          'included.requirementFiles'
                        )}
                      />
                    </TabPanel>
                    <TabPanel>
                      <FeesInformation
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    {/* {transactionStatus === 'FOR CHECKING' &&
                      isStartAssessment === 1 && (
                        <TabPanel>
                          <FeesTags type="marriage" />
                        </TabPanel>
                      )} */}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

MarriageContent.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  selectedBirth: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  isAssessting: PropTypes.bool.isRequired,
  cancelApplication: PropTypes.instanceOf(Function).isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
  onCancelAssessment: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  isAssessting: _.get(api, 'loading', []).indexOf(c.START_ASSESSMENT) > -1,
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  approving: _.get(api, 'loading', []).indexOf(c.APPROVE_TRANSACTION) > -1,
  selectedBirth: _.get(match, 'params.id') || '',
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(MarriageContent);
